import { createSlice } from "@reduxjs/toolkit";
import { loginUser } from "./loginApi";
import { logoutUser } from "./loginApi";
import { toast } from "react-toastify";


export const loginSlice = createSlice({
    name: 'login',
    initialState: {
        isActivate: false,
        username: "",
        token: null,
        navigation: "LOGIN",
        pageName: "Mancore"
    },
    reducers: {
        setToken: (state, action) => {

            state.token = action.payload
        },
        active: (state) => {
            state.isActivate = true
        },
        deactive: (state) => {
            state.isActivate = false
        },
        logout: (state) => {
            //state.isActivate = false
            //state.username = ""
            //state.password = ""
            //state.token = ""
        },
        reset: (state) => {
            //state.isActivate = false
            // state.username = ""
            // state.password = ""
            // state.status = ""
            //state.token = ""
            //console.log("RESET!!!!")
        },
        setPageName: (state, action) => {
            state.pageName = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(loginUser.fulfilled, (state, action) => {
            state.isActivate = true;
            state.username = action.meta.arg.username
            state.token = action.payload.auth_token
            state.navigation = "CONTROL"
            state.status = "SUCCESS"
            console.log('SUCCESS')
            localStorage.setItem("token", JSON.stringify(state.token))


            //let navigate = useNavigate();
            //navigate("/control", { replace: true });
        })
        builder.addCase(loginUser.pending, (state, action) => {
            state.status = 'LOGIN'

        })

        builder.addCase(loginUser.rejected, (state, action) => {
            let message = "Что-то пошло не так!"
            if (action.error.message== "Request failed with status code 400"){
                localStorage.clear()
                state.token =null
                message = "Неверный логин или пароль!"
            }
            toast.error(message, {
                position: "bottom-left",
                autoClose: 1000,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });

        })


        builder.addCase(logoutUser.fulfilled, (state, action) => {

            state.isActivate = false;
            localStorage.setItem("token", JSON.stringify(null))
            state.token = ""
            //let navigate = useNavigate();
            //navigate("/control", { replace: true });
        })
        builder.addCase(logoutUser.pending, (state, action) => {
            state.isActivate = false;
            localStorage.setItem("token", JSON.stringify(null))
            state.username = ""
            state.token = null
        })
        builder.addCase(logoutUser.rejected, (state, action) => {
            console.log("REJECTED")
            state.isActivate = false;
            state.username = ""

        })

    }
})

export const { active, deactive, authorizate, logout, reset, setPageName, setToken } = loginSlice.actions

export default loginSlice.reducer
